<div class="wrapper">
	<h3 class="title">{{ 'filter_section.filter' | translate }}</h3>
	<div class="filter_wrapper">
		@for (item of listFilters; track $index) {
			<div class="filter_item" role="region" aria-label="Filter item">
				<p>{{ item.name | translate }}</p>
				<div>
					<ion-toggle [checked]="addedFilters.includes(item.value)" (ionChange)="changeVariable($event, item.value)"></ion-toggle>
				</div>
			</div>
		}
	</div>
	<div>
		<ion-button (click)="selectFilters()">Filter</ion-button>
	</div>
</div>
